export default class WorkerRole {

  id = null;
  name = "";
  requireCertificate = false;

  constructor() {
  }
}
